module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{},"ru":{"title":"Действия","change_rate":"Изменить оценку","my":"Показывать моё мнение","community":"Показывать мнение сообщества"}}')
  delete Component.options._Ctor
}
